import React from 'react';

export const RecaptchaContext = React.createContext<{
  ref: React.RefObject<{ execute: () => void }>;
  executeAsync: () => Promise<string>;
}>(null);
